<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1839kam/tc-custom/9781459223707.jpg?1705766069532" alt="This image is the cover for the book Daddy Lessons, Home to Hartley Creek"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Daddy Lessons, Home to Hartley Creek
      </h1>
      <p class="bookDescription body article font2">
        <p>Her high school sweetheart is the last person teacher Hailey Deacon expects to encounter back home in Hartley Creek. Since Dan Morrow closed the door on their future, Hailey's determined to make this a temporary stay. She has an ill grandmother to take care of. But when Dan, now a widower, brings his troubled six-year-old daughter to Hailey for help, how can she refuse? Working with both father and daughter, she vows not to fall for him again. But if a determined little girl has her way, Hailey won't be leaving  Hartley Creek again anytime soon.<br/><br/>Home to Hartley Creek:<br/><br/>A family legend brings cousins home.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carolyne Aarsen
      </h2>
      
      <p class="authorDescription body article">Carolyne Aarsen lives in Northern Alberta where she was born, raised and married and has raised four children and numerous foster children. Carolyne&#39;s writing has been honed between being a stay-at-home mother, housewife, gardener, crafter columnist and business partner with her husband in their cattle farm and logging business. Writing for Love Inspired has given her the chance to combine her love of romance writing with her love for the Lord.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69065924